export class SchoolMapView {
    id: number;
    schoolAcctNumber: number;
    iakSchoolName: string;
    oneRosterSchoolId: number;
    syncStudents: boolean;
    syncStudentContacts: boolean;
    updatedAt: Date;

    constructor() {
        this.id = 0;
        this.schoolAcctNumber = 0;
        this.iakSchoolName = '';
        this.oneRosterSchoolId = 0;
        this.syncStudents = true;
        this.syncStudentContacts = true;
        this.updatedAt = new Date();
    }
}